import type { Ref } from 'react';
import type { Types } from '@marriott/mi-ui-library';

export type List = {
  brandtag: string;
  openinanewtab: boolean;
  linkurl: string;
  linkText: string;
  clickTrackValue?: string;
  custom_click_track_value?: string;
  trackingDescription?: string;
};

export type LinkLists = {
  linklists: List[];
  categorylabel: string;
  description?: string;
};

export interface BrandRibbonProps {
  componentId?: string;
  enableScrollingBehavior?: boolean;
  variations?: BrandRibbonVariation;
  brandLogoTag?: string;
  logoLinkText?: string;
  ctaLink?: string;
  header?: string;
  categorylists: LinkLists[];
  trackingProperties?: Types.TrackingPropsInterface;
  styleclass?: string;
  cqPath?: string;
  forwardedRefs?: Ref<HTMLAnchorElement | null>[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  featureFlagLogo?: any;
}

export enum BrandRibbonVariation {
  PortfolioRibbon = 'portfolioribbon',
  PortfolioBrands = 'portfoliobrands',
  BrandRibbon = 'brandribbon',
}
